import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import { Box, Text, Heading, Button } from 'grommet';

const styles = {

}

class NotificationComponent extends React.Component {

  componentDidMount() {
    const { item, deleteNotificationsFromQueue } = this.props;
    setTimeout(() => {
        deleteNotificationsFromQueue(item['id'])
    }, item['timeout'] || 3000)
  }

  render() {
    const { item, deleteNotificationsFromQueue } = this.props;
    return (
      <Box direction='row' align="center" pad="10px" background={item.color} margin={{'bottom': '5px'}} width="300px">
        <Heading margin={{'right': '10px'}} level="4">{item.title}</Heading>
        <Text>{item.body}</Text>
        <Button
          margin={{'left': '10px'}}
          plain={true}
          label=<i className='fa fa-times'></i>
          onClick={() => { deleteNotificationsFromQueue(item['id']) }}
        />
      </Box>
    );
  }
}

NotificationComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  item: PropTypes.object.isRequired,
  deleteNotificationsFromQueue: PropTypes.func.isRequired
};

export default withStyles(styles)(NotificationComponent);
